export default __webpack_public_path__ + "static/media/screen7.bf8e8123.png";